var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileRecruitDesktopIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 308.133,
    height: 232.187,
    viewBox: "0 0 308.133 232.187",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mobile_recruit_desktop_icon",
    transform: "translate(-33.499 -430.582)",
    opacity: 0.397
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186011",
    "data-name": "\\uADF8\\uB8F9 186011",
    transform: "translate(-713.513 400.592)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154612",
    "data-name": "\\uC0AC\\uAC01\\uD615 154612",
    d: "M0,0H239.657a0,0,0,0,1,0,0V6.1a4.358,4.358,0,0,1-4.358,4.358H4.358A4.358,4.358,0,0,1,0,6.1V0A0,0,0,0,1,0,0Z",
    transform: "translate(781.251 251.223)",
    fill: "none",
    stroke: "#1876d2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139000",
    "data-name": "\\uD328\\uC2A4 139000",
    d: "M796.773,90.338a24.154,24.154,0,0,0-24.155-24.155H513.8A24.156,24.156,0,0,0,489.64,90.338v129.41H796.773Z",
    transform: "translate(257.872 -35.693)",
    fill: "#fff",
    stroke: "#1876d2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186010",
    "data-name": "\\uADF8\\uB8F9 186010",
    transform: "translate(756.239 39.214)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132678",
    "data-name": "\\uD328\\uC2A4 132678",
    d: "M493.278,214.661V85.251A15.448,15.448,0,0,1,508.709,69.82h258.82a15.449,15.449,0,0,1,15.431,15.431v129.41Z",
    transform: "translate(-493.278 -69.82)",
    fill: "#fff",
    stroke: "#1876d2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139001",
    "data-name": "\\uD328\\uC2A4 139001",
    d: "M513.8,164.231h258.82a24.154,24.154,0,0,0,24.155-24.155V130.2H489.64v9.873A24.156,24.156,0,0,0,513.8,164.231Z",
    transform: "translate(257.872 53.854)",
    fill: "#fff",
    stroke: "#1876d2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_21792",
    "data-name": "\\uD0C0\\uC6D0 21792",
    cx: 4.363,
    cy: 4.363,
    rx: 4.363,
    ry: 4.363,
    transform: "translate(313.733 598.906)",
    fill: "none",
    stroke: "#1876d2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186014",
    "data-name": "\\uADF8\\uB8F9 186014",
    transform: "translate(-0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_1698",
    "data-name": "\\uC120 1698",
    y2: 33.569,
    transform: "translate(147.5 618.5)",
    fill: "none",
    stroke: "#1876d2",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_1699",
    "data-name": "\\uC120 1699",
    y2: 33.569,
    transform: "translate(229.5 618.5)",
    fill: "none",
    stroke: "#1876d2",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileRecruitDesktopIcon);
export default __webpack_public_path__ + "static/media/mobile_recruit_desktop_icon.a2191b7cf40eee9f24b8302c40514b7f.svg";
export { ForwardRef as ReactComponent };